import React, { useContext, useState, useEffect } from 'react';
import { constantes } from '../../../../constantes';
import CidadesContext from '../../../../context/cidades.context';
import UsuarioContext from '../../../../context/usuario.context';
import PosicoesContext from '../../../../context/posicoes.context';
import './header.scss';

export function HeaderOptions() {
  const { listCity, listUf, handleChange } = useContext(CidadesContext);
  const {
    setarInformacoes, enableIputHeader,
    setEnabledInputHeader, temp, setInput,
  } = useContext(PosicoesContext);
  const { usuario } = useContext(UsuarioContext);
  const [listaDePermissoes, setListaDePermissoes] = useState([]);

  function organizarPermissoes() {
    if (usuario.state !== constantes.aguardandoAtivacao) {
      const { valor, tipo } = constantes.tipoCadastro
        .find((result) => result.valor === usuario.tipoDeCadastro);
      const result = [...usuario.premissoes, { permitido: { valor, tipo } }];
      const newList = result.map((curr) => (
        { valor: curr.permitido.valor, tipo: curr.permitido.tipo }));
      newList.sort((a, b) => {
        if ((a.valor > b.valor)) {
          return 1;
        } if ((b.valor > a.valor)) {
          return -1;
        }
        return 0;
      });
      setListaDePermissoes(newList);
    }
  }

  useEffect(() => {
    organizarPermissoes();
  }, [usuario.uid]);

  return (
    <div id="header-novo-cadastro">
      <label id="label-tipo" className="tipo">
        <span>
          Tipo de Cadastro
        </span>
        <select
          className="form-control"
          name="tipo"
          id="tipo"
          onChange={(e) => {
            setarInformacoes(e, setInput((prevState) => ({
              ...prevState, [`${e.target.name}`]: e.target.value,
            })));
            if (e.target.value !== 'Selecione') {
              setEnabledInputHeader((prevState) => ({
                ...prevState,
                tipo: e.target.value !== 'Selecione',
                estado: e.target.value !== 'Selecione',
              }));
            } else {
              setEnabledInputHeader((prevState) => ({
                ...prevState,
                tipo: e.target.value !== 'Selecione',
                estado: e.target.value !== 'Selecione',
                cidade: e.target.value !== 'Selecione',
              }));
            }
          }}
        >
          <option selected={!enableIputHeader.estado} value="Selecione">Selecione</option>
          {listaDePermissoes.map(({ valor }) => (
            <option value={valor}>{valor}</option>
          ))}
        </select>
      </label>
      <label id="label-estado" className="estado">
        <span>
          Informe Estado
        </span>
        <select
          className="form-control"
          id="estado-header"
          name="estado"
          disabled={!enableIputHeader.estado}
          onChange={(e) => {
            handleChange(e);
            for (let index = 0; index < listUf.length; index += 1) {
              const element = listUf[index];
              if (listUf[index].id === parseInt(e.target.value, 10)) {
                setarInformacoes({ target: { name: 'estado', value: element.sigla } });
              }
            }
            setEnabledInputHeader((prevState) => ({
              ...prevState,
              cidade: e.target.value !== '-- ESTADO --',
            }));
          }}
        >
          <option estado="-- ESTADO --" selected={!enableIputHeader.estado} value="-- ESTADO --">
            -- ESTADO --
          </option>
          {listUf.map((a) => (
            <option estado={a.nome} value={a.id}>{a.nome}</option>
          ))}
        </select>
      </label>
      <label id="label-cidade" className="cidade">
        <span>
          Informe a cidade
        </span>
        <select
          className="form-control"
          name="cidade"
          id="cidade-header"
          required
          disabled={!enableIputHeader.cidade}
          value={temp.cidade}
          onChange={(e) => {
            handleChange(e);
            setarInformacoes(e, setInput((prevState) => ({
              ...prevState, [`${e.target.name}`]: e.target.value,
            })));
          }}
        >
          {listCity.map((a) => (
            enableIputHeader.cidade && <option value={a.sigla}>{a.nome}</option>
          ))}
        </select>
      </label>
    </div>
  );
}
